module.exports = __webpack_public_path__ + "static/media/hdfc.9beeaaec.svg";